import { isAnyRealEstateCategory } from '@kijiji/category'
import { type UserLocation, ResultsView } from '@kijiji/generated/graphql-types'

import { shouldAllowGridView } from '@/features/search/utils/shouldAllowGridView'

export const getAvailableViewOptions = ({
  categoryId,
  currentView,
  location,
  isGridViewEnabled,
  isRealEstateGridExpEnabled,
}: {
  categoryId: number
  currentView: ResultsView
  isGridViewEnabled?: boolean
  isRealEstateGridExpEnabled?: boolean
  location: UserLocation
}): ResultsView[] => {
  let availableViewTypes = [ResultsView.List]

  if (isGridViewEnabled && shouldAllowGridView(categoryId)) {
    availableViewTypes.push(ResultsView.Grid)
  }

  // if real estate grid test group, show grid view
  if (isRealEstateGridExpEnabled && isAnyRealEstateCategory(categoryId)) {
    // for the experiment test group, we will be removing list view
    availableViewTypes = availableViewTypes.filter((viewType) => viewType !== ResultsView.List)
    availableViewTypes.push(ResultsView.Grid)
  }

  if (isAnyRealEstateCategory(categoryId) && !location.isRegion && location.area) {
    availableViewTypes.push(ResultsView.Map)
  }

  return availableViewTypes.filter((item) => item !== currentView)
}
